import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";

export interface IUpsellInsightData {
  [key: string]: any;
}

export interface IUpsellLeadsState {
  insight: {
    data: IUpsellInsightData[] | null;
    loading: LoadState;
  };
  recommendedTemplate: {
    data: any;
    loading: LoadState;
  };
}

export const initialUpsellLeadsState: IUpsellLeadsState = {
  insight: {
    data: null,
    loading: LoadState.NotLoaded,
  },
  recommendedTemplate: {
    data: null,
    loading: LoadState.NotLoaded,
  },
};

export const fetchUpsellInsightAsync =
  (
    _payload: any,
    onSuccess?: (isSuccess?: boolean, data?: any) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async () => {
      onSuccess?.(true, []);
    };

export const fetchRecommendedTemplateAsync =
  (
    _payload: any,
    onSuccess?: (isSuccess?: boolean, data?: any) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async () => {
      onSuccess?.(true, null);
    };

export const clearRecommendedTemplateState = () => ({
  type: "CLEAR_RECOMMENDED_TEMPLATE_STATE",
});

export const autoGenerateCampaignAsync =
  (
    _payload: any,
    onSuccess?: (isSuccess?: boolean, data?: any) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async () => {
      onSuccess?.(true, null);
    };

export * from "./upsellLeads.types";
export * from "./upsellLeadsActions";
